export default {
  eyebrow: 'Filter',
  heading: 'Find another office.',
  heading_size: 'h4',
  copy: null,
  cta: [],
  component: 'm-filter-office',
}
